import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=4ffb709b&"
import script from "./TermsModal.vue?vue&type=script&lang=ts&"
export * from "./TermsModal.vue?vue&type=script&lang=ts&"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=4ffb709b&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports